export default "/server-build/img/193f21063d42deed3a7e3f467ba1ee66.png";